import script from "./StandardA4X2NADW5.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardA4X2NADW5.vue?vue&type=script&setup=true&lang=js"

import "./StandardA4X2NADW5.vue?vue&type=style&index=0&id=37ac7458&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ac7458"]])

export default __exports__